import { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeHighlight from 'rehype-highlight';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { strapiBaseURL } from 'api/http-client';
import './renderer.scss';
import { interpolateMarkdown } from './helpers';

type Props = {
  content: string;
  variables?: Record<string, string>;
  anchorContactUsEmail?: () => JSX.Element;
}

const MarkdownRenderer: FC<Props> = ({ 
  content,
  variables = {},
  anchorContactUsEmail
}) => {
  const interpolatedContent = interpolateMarkdown(content, variables)
  const filteredContent = interpolatedContent.replace(
    /\]\((\/uploads\/[^\)]+)\)/g, 
    `](${strapiBaseURL}$1)`
  );

  return (
    <div className="renderer__wrapper">
      <ReactMarkdown 
        rehypePlugins={[rehypeHighlight, rehypeRaw]} 
        remarkPlugins={[remarkGfm]}
        components={{
          a: ({ href, children }) => {
            if ((href === 'mailto:info@virtualhospice.ca' || href === 'mailto:info@portailpallatif.ca') && anchorContactUsEmail) {
              return anchorContactUsEmail();
            }

            return (
              <a 
                href={href} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                {children}
              </a>
            );
          }
        }}
      >
        {filteredContent}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
